<template>
    <div class="flex flex-shrink-0">
        <div v-if="!user" class="flex w-full justify-center items-center space-x-2 py-4">
            <div>
                <Link :href="route('register')" class="button-primary">Create Account</Link>
            </div>
            <div>
                <Link :href="route('login')" class="button-default">Login</Link>
            </div>
        </div>
        <div v-if="user" class="p-4">
            <a href="#" class="group block w-full flex-shrink-0">
                <div class="flex items-center">
                    <div>
                        <img
                            class="inline-block h-9 w-9 rounded-full object-fill"
                            :src="$page.props.user.profile_photo_url"
                            alt="">
                    </div>
                    <div class="ml-3">
                        <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900"> {{ user.name }}</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';
import {Link} from '@inertiajs/vue3';

export default {
    components: {
        Link
    },
    setup() {
        const user = computed(() => usePage().props.user);

        return {user};
    },
};
</script>
